$('#tipo_producto').autoComplete({
    minLength:2,
    noResultsText: "Sin resultados",
    resolver:'custom',
    bootstrapVersion:"4",
    events: {
        search:function (qry, callback) {
            $.ajax({
                url: url_base+"/api/tipoProductoAutocomplete",
                dataType: 'json',
                data: {
                    'qry': qry
                },
                beforeSend: function(){
                },
                error: function(){
                    console.error("error");
                },
                success: function(data){
                    callback(data);
                }
            });
        }
    }
}).on("keyup change",function(e){
    $('#subtipo_producto').attr('readonly',$(this).val().length<3);
})

$('#subtipo_producto').autoComplete({
    minLength:2,
    noResultsText: "Sin resultados",
    resolver:'custom',
    bootstrapVersion:"4",
    events: {
        search:function (qry, callback) {
            $.ajax({
                url: url_base+"/api/subtipoProductoAutocomplete",
                dataType: 'json',
                data: {
                    'qry': qry,
                    'tipo': $("#tipo_producto").val()
                },
                beforeSend: function(){
                },
                error: function(){
                    console.error("error");
                },
                success: function(data){
                    callback(data);
                }
            });
        }
    }
});

$('#marca_producto').autoComplete({
    minLength:2,
    noResultsText: "Sin resultados",
    resolver:'custom',
    bootstrapVersion:"4",
    events: {
        search:function (qry, callback) {
            $.ajax({
                url: url_base+"/api/marcaProductoAutocomplete",
                dataType: 'json',
                data: {
                    'qry': qry
                },
                beforeSend: function(){
                },
                error: function(){
                    console.error("error");
                },
                success: function(data){
                    callback(data);
                }
            });
        }
    }
});


$('#color_producto').autoComplete({
    minLength:1,
    noResultsText: "Sin resultados",
    resolver:'custom',
    bootstrapVersion:"4",
    events: {
        search:function (qry, callback) {
            $.ajax({
                url: url_base+"/api/colorProductoAutocomplete",
                dataType: 'json',
                data: {
                    'qry': qry
                },
                beforeSend: function(){
                },
                error: function(){
                    console.error("error");
                },
                success: function(data){
                    callback(data);
                }
            });
        }
    }
});

if(document.getElementById('tipo_producto')&&document.getElementById('subtipo_producto')){
    $("#tipo_producto").trigger('change');
}

eliminarProducto = function(e){
    var data = e.dataset;
    $("#form_eliminar_producto")[0].reset();
    $("#eliminar_producto_id").val(data.id);
    $("#eliminar_producto_nombre").html(`¿Deseas eliminar el producto <strong>${data.nombre}</strong>?`);
}